import {cubbyRequest} from "../helpers/api";

export const fetchMetaData = (partnerId, locationId) => {
    return new Promise((resolve, reject) => {
        cubbyRequest('GET', `meta-data/byPartner/${partnerId}/byLocation/${locationId}`).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
};

export const assignCubby = (cubbyOrderInfo) => {
    return new Promise((resolve, reject) => {
        cubbyRequest('POST', `cubby/assign`, cubbyOrderInfo).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
};